import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/Frame.png';
const _hoisted_1 = {
    key: 0,
    class: "simplePage"
};
const _hoisted_2 = { class: "anchor-bottom" };
const _hoisted_3 = ["href"];
const _hoisted_4 = {
    class: "simplePage",
    style: { "color": "black", "overflow-y": "scroll" }
};
const _hoisted_5 = ["href"];
import { ref, getCurrentInstance, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useBanking } from '@/composables/useBanking';
import DrawerPanel from './elements/DrawerPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LinkOpenBankingAccountPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getOpenBankingLinkUrl } = useBanking();
        const cookies = getCurrentInstance()?.appContext.config.globalProperties.$cookies;
        const drawer = ref(null);
        function onLoad() {
            getCustomer();
        }
        function continueNext(linking) {
            if (linking) {
                cookies?.set('waitBank', true);
            }
            router.replace({ path: '/' });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    bgcolor: "#00000000",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                (_unref(state).customer)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Money Guided works with your bank accounts", -1)),
                        _cache[6] || (_cache[6] = _createElementVNode("img", {
                            class: "smallHeroImg",
                            src: _imports_0
                        }, null, -1)),
                        _cache[7] || (_cache[7] = _createElementVNode("p", null, "Linking your bank accounts and credit cards to Money Guided gives you a clear and accurate picture of your financial situation without the hassle of manually tracking transactions.", -1)),
                        _createElementVNode("div", {
                            onClick: _cache[0] || (_cache[0] = ($event) => (drawer.value?.openDrawer()))
                        }, "Understand Our Security"),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("a", {
                                href: _unref(getOpenBankingLinkUrl)(_unref(state).customer.id),
                                target: "_blank"
                            }, [
                                _createVNode(MGButton, {
                                    onClick: _cache[1] || (_cache[1] = ($event) => (continueNext(true))),
                                    text: "Let's do it",
                                    alt: "true",
                                    small: false
                                })
                            ], 8, _hoisted_3),
                            _createElementVNode("div", {
                                class: "mt-2",
                                onClick: _cache[2] || (_cache[2] = ($event) => (continueNext(false)))
                            }, "Skip for now")
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_unref(state).customer)
                    ? (_openBlock(), _createBlock(DrawerPanel, {
                        key: 1,
                        ref_key: "drawer",
                        ref: drawer,
                        closedHeight: "0px",
                        openBackgroundColor: 'white',
                        bottom: "0px",
                        openHeight: "80%",
                        title: "Our Security"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_v_icon, {
                                    icon: "mdi-bank-check",
                                    class: "smallHeroImg"
                                }),
                                _cache[8] || (_cache[8] = _createElementVNode("p", null, "Money Guided's open banking empowers you with seamless financial management, leveraging bank-grade security protocols to ensure your data's utmost protection. With rigorous regulatory oversight, encrypted connections, and strong customer authentication, your financial information is safeguarded, giving you the confidence to enjoy the benefits of streamlined, automated financial insights.", -1)),
                                _createElementVNode("a", {
                                    href: _unref(getOpenBankingLinkUrl)(_unref(state).customer.id),
                                    target: "_blank"
                                }, [
                                    _createVNode(MGButton, {
                                        onClick: _cache[3] || (_cache[3] = ($event) => (continueNext(true))),
                                        text: "Let's do it",
                                        alt: "true",
                                        small: false
                                    })
                                ], 8, _hoisted_5),
                                _createElementVNode("div", {
                                    class: "mt-2",
                                    onClick: _cache[4] || (_cache[4] = ($event) => (continueNext(false)))
                                }, "Skip for now")
                            ])
                        ]),
                        _: 1
                    }, 512))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
